﻿﻿import { IntakeWorkflowConfig } from '../enums/index';
import { RemissionStatus } from '../enums/index';
import { DiabetesStatus } from '../enums/index';
import { PreWorkupLabConfig } from '../enums/index';
import { ICancerRejection } from './cancer-rejection';
import { IKidneyStoneRejection } from './kidney-stone-rejection';

export interface IDashIntakeConfig {
    centerId: number;
    useQuickStart: boolean;
    askSexualSocialQuestions: boolean;
    doRealTimeEval: boolean;
    callbackBusinessDays: number;
    dashDonorDaysToExpire: number;
    yearsForFollowUpLabs: number;
    recipientMaxAge: number;
    donorMaxAge: number;
    intakeWorkflowConfig: IntakeWorkflowConfig;
    dashDonorDaysToExpireTextP: string;
    dashUsesPwlQuest: boolean;
    dashUsesPwlPhlebot: boolean;
    dashUsesPwlAtMiles: number;
    usesPwlForNdd: boolean;
    usesPwlForAdp: boolean;
    usesPwlForLongDistanceDonors: boolean;
    bmiLimit: number;
    bmiRequiredForSurgery: number;
    minAgeNdd: number;
    minAgeDd: number;
    mustAcceptBloodTransfusions: boolean;
    ruleOutOnGestationalDiabetes: boolean;
    ruleOutOnKidneyDisease: boolean;
    alwaysRuleOutOnHeartAttack: boolean;
    requireQuitTobacco: boolean;
    heartAttackRemissionRequired: RemissionStatus;
    diabetesFailLevel: DiabetesStatus;
    preWorkupLabConfig: PreWorkupLabConfig;
    cancerRejection: ICancerRejection[];
    cancerRejectionJson: string;
    kidneyStoneRejection: IKidneyStoneRejection[];
    kidneyStoneRejectionJson: string;
    referDonorToNkr: boolean;
}
